import { reviewerInvite } from '@/api/reviewer'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      detail: {}
    }
  },
  computed: {
    ...mapGetters({
      manuscriptType: 'getManuscriptType'
    })
  },
  mounted() {
    const { id, sign } = this.$route.query
    this.getQuery(id, sign)
  },
  methods: {
    async getQuery(id, sign) {
      this.detail = await reviewerInvite.query(id, { sign })
    },
    cancel() {
      this.$router.push('/reviewers-menu/reviews')
    },
    async submit() {
      let data = {
        id: this.detail.id,
        status: 'AGREED',
        version: this.detail.version
      }
      await reviewerInvite.confirm(data)
      this.$router.push(
        `/reviewers-menu/reviews/reviews-agree?id=${this.detail.id}&version=${this.detail.version}`
      )
    }
  }
}
